import { render, staticRenderFns } from "./dePrivacy.vue?vue&type=template&id=3377845d&scoped=true&"
import script from "./dePrivacy.vue?vue&type=script&lang=js&"
export * from "./dePrivacy.vue?vue&type=script&lang=js&"
import style0 from "./dePrivacy.vue?vue&type=style&index=0&id=3377845d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3377845d",
  null
  
)

export default component.exports